export enum WindowHapiSubmoduleName {
    "api" = "hapiApi",
    auth = "hapiAuth",
    config = "hapiConfig",
    instances = "hapiInstances",
    qa = "hapiQA",
    routing = "hapiRouting",
    sdk = "hapi",
    service = "hapiService",
    state = "hapiState",
    ui = "hapiUI",
    utils = "hapiUtils",
    validation = "hapiValidation",
    events = "hapiEvents",
    instance = "hapiInstance",
}

export enum WindowHapiModuleName {
    router = "router",
    config = "config",
    ats = "ats",
    basket = "basket",
    campaign = "campaign",
    contract = "contract",
    product = "product",
    "common" = "common",
    wallet = "wallet",
    debugging = "debugging",
    language = "language",
    theming = "theming",
    orderJourney = "orderJourney",
    userJourney = "userJourney",
    alert = "alert",
    modal = "modal",
    "ui" = "ui",
}

export enum WindowHapiSDKModuleName {
    api = "api",
    state = "state",
    validation = "validation",
    service = "service",
    utils = "utils",
}
